module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_right_black-9784eba333abc71934c44b91f24fcf47.svg";